<template>
  <Modal
    :modal-style="{ maxWidth: '900px' }"
    title="Request a Media Item"
  >
    <div class="card q-pa-lg column">
      <div class="row">
        <div class="col-6 q-pr-md">
          <div class="bold q-mb-sm">
            {{ type }}
          </div>
          <div>{{ source.name }} {{ source.locationName }}</div>
        </div>
        <div class="col-6 q-mb-lg">
          <div class="bold q-mb-sm">From</div>
          <div>{{ dateYmdhms(mentionStartTime) }}</div>
        </div>
      </div>

      <OrganisationsDropdown
        v-model="organisationId"
        emit-value
        filled
        label="Organisation"
        @update:model-value="loadUsers"
      />

      <SelectList
        v-model="userId"
        clearable
        emit-value
        label="User"
        option-label="name"
        :options="users"
      />
      <!-- Context and Duration textarea -->
      <Field
        :id="form.contextDuration.id"
        v-model="form.contextDuration.value"
        :error-message="form.contextDuration.errorMessage"
        :has-error="
          form.contextDuration.hasError && form.contextDuration.value === ''
        "
        :has-focus="form.contextDuration.hasFocus"
        :label="form.contextDuration.label"
        :placeholder="form.contextDuration.placeholder"
        :required="form.contextDuration.required"
        :resizable="form.contextDuration.resizable"
        :type="form.contextDuration.type"
        @blur-event="form.contextDuration.hasFocus = false"
      />
    </div>

    <template #buttons>
      <BaseButton
        color="primary"
        label="Request Media Item"
        new-design
        @click="send"
      />
    </template>
  </Modal>
</template>

<script>
import BaseButton from "shared/components/base/BaseButton.vue";
import Modal from "shared/components/core/modals/Modal.vue";
import { dateYmdhms } from "shared/helpers/date";
import { MediaRequest, User } from "shared/resources";

import OrganisationsDropdown from "src/components/common/OrganisationsDropdown.vue";

export default {
  name: "MediaItemModal",
  components: {
    Modal,
    BaseButton,
    OrganisationsDropdown,
  },
  props: {
    sourceType: {
      type: String,
      required: true,
    },
    clip: {
      type: Object,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
  },
  emits: ["success"],
  data() {
    return {
      form: {
        contextDuration: {
          id: "context-duration",
          type: "textarea",
          label: "Context and duration",
          placeholder:
            "Please provide a detailed description of the content and context of the requested Media Item. This will assist Streem in quickly delivering you a relevant TV or Radio Media Item.",
          errorMessage: "The context and duration is required",
          hasError: false,
          hasFocus: true,
          required: true,
          value: "",
          resizable: false,
        },
      },
      organisationId: null,
      users: [],
      userId: null,
    };
  },
  computed: {
    type() {
      return this.sourceType === "tv" ? "TV Channel" : "Radio Station";
    },
    mentionStartTime() {
      return this.clip.start_time;
    },
    sourceId() {
      return this.source.id;
    },
  },
  methods: {
    dateYmdhms,
    loadUsers() {
      const filters = {
        organisationId: { eq: this.organisationId },
        active: { eq: true },
      };

      return User.where(filters)
        .page(1)
        .per(999)
        .all()
        .then(({ data }) => {
          this.users = data;
        });
    },
    async send(cancel) {
      this.$q.loading.show({ delay: 0 });

      try {
        const attrs = {
          userId: this.userId,
          startTime: this.clip.start_time * 1000,
          endTime: this.clip.end_time * 1000,
          notes: this.form.contextDuration.value,
          sourceType: this.sourceType === "tv" ? "TvChannel" : "RadioStation",
          sourceId: this.sourceId,
        };

        const mediaRequest = new MediaRequest(attrs);
        await mediaRequest.save();
        this.$emit("success");
      } catch (error) {
        this.$error("There was an error saving this Media Item.", error);
        cancel();
      } finally {
        this.$q.loading.hide();
      }
    },
  },
};
</script>
